/* taio-powiadomienie: zapis na powiadomienie o dostepnosci (snippet taio-powiadomienie).
   Klaviyo, API klienta, publiczny identyfikator konta. Najpierw zapis na powrot produktu,
   potem, tylko po zaznaczeniu pola, zapis na newsletter (lista Rrbnki „Newsletter | Powiadomienie o dostepnosci”,
   podwojne potwierdzenie, bez serii powitalnej; kampanie i tak ja obejmuja przez segment „Cala lista mailowa”).
   Blad zapisu na newsletter nie psuje zapisu na powiadomienie, ktory jest celem formularza. */
(function () {
  var KONTO = 'YySZer';
  var LISTA = 'Rrbnki';
  var REWIZJA = '2024-10-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function wyslij(sciezka, cialo) {
    return fetch('https://a.klaviyo.com/client/' + sciezka + '/?company_id=' + KONTO, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REWIZJA },
      body: JSON.stringify(cialo)
    }).then(function (r) {
      if (!r.ok) throw new Error('klaviyo ' + r.status);
    });
  }

  function zapiszPowiadomienie(email, wariant) {
    return wyslij('back-in-stock-subscriptions', {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + wariant } }
        }
      }
    });
  }

  function zapiszNewsletter(email, zrodlo) {
    return wyslij('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Powiadomienie o dostepnosci',
          profile: { data: { type: 'profile', attributes: { email: email, properties: { zrodlo: 'powiadomienie-' + zrodlo } } } }
        },
        relationships: { list: { data: { type: 'list', id: LISTA } } }
      }
    });
  }

  function init(box) {
    var form = box.querySelector('[data-taio-pow-form]');
    var pole = form.querySelector('input[name="email"]');
    var zgoda = form.querySelector('input[name="newsletter"]');
    var blad = form.querySelector('[data-taio-pow-blad]');
    var cta = form.querySelector('[data-taio-pow-cta]');
    var pasek = box.querySelector('[data-taio-pow-pasek]');
    var gotowe = box.querySelector('[data-taio-pow-gotowe]');
    var potwierdz = box.querySelector('[data-taio-pow-potwierdz]');
    var ctaTekst = cta.textContent;

    function pokazBlad(tekst) {
      blad.textContent = tekst;
      blad.hidden = false;
    }

    /* Wariant bierzemy z formularza produktu w chwili zapisu, gdyby klient zmienil wariant. */
    function biezacyWariant() {
      var formProduktu = document.getElementById(box.getAttribute('data-form-produktu'));
      var input = formProduktu && formProduktu.querySelector('input[name="id"]');
      return (input && input.value) || box.getAttribute('data-wariant');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      blad.hidden = true;
      var email = (pole.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        pokazBlad('Sprawdź adres e-mail.');
        pole.focus();
        return;
      }
      cta.disabled = true;
      cta.textContent = 'Zapisuję…';
      var chceNewsletter = !!(zgoda && zgoda.checked);

      zapiszPowiadomienie(email, biezacyWariant())
        .then(function () {
          if (!chceNewsletter) return false;
          return zapiszNewsletter(email, box.getAttribute('data-zrodlo')).then(
            function () { return true; },
            function () { return false; }
          );
        })
        .then(function (zapisanyNewsletter) {
          form.hidden = true;
          if (pasek) pasek.hidden = true;
          gotowe.hidden = false;
          if (potwierdz) potwierdz.hidden = !zapisanyNewsletter;
        })
        .catch(function () {
          cta.disabled = false;
          cta.textContent = ctaTekst;
          pokazBlad('Nie udało się zapisać. Spróbuj jeszcze raz albo napisz do nas: hello@taio.care.');
        });
    });
  }

  document.querySelectorAll('[data-taio-pow]').forEach(init);
})();
